import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {BREADCRUMBS_SLICE} from './constants';
import {
    IBreadcrumbsSliceState,
    TBreadcrumbsSetPayload,
    TCrumbSetPayload,
} from './types';

const initialState: IBreadcrumbsSliceState = {
    breadcrumbsInitialState: {breadcrumbs: []},
};

export const breadcrumbsSlice = createSlice({
    initialState,
    name: BREADCRUMBS_SLICE,
    reducers: {
        setBreadcrumbs(state, {payload}: PayloadAction<TBreadcrumbsSetPayload>) {
            state[payload.entityName] = {
                breadcrumbs: [...(payload.breadcrumbs || [])],
            };
        },
        replaceBreadcrumbs(state, {payload}: PayloadAction<TCrumbSetPayload>) {
            const newBreadcrumbsData = state[payload?.entityName]?.breadcrumbs || [];
            const index = newBreadcrumbsData.findIndex(item => item.key === payload.crumb.key);
            newBreadcrumbsData.splice(index, newBreadcrumbsData.length, {
                ...payload.crumb,
            });
            return ({
                ...state,
                [payload.entityName]: {
                    breadcrumbs: [...newBreadcrumbsData],
                },
            });
        },
        pushCrumb(state, {payload}: PayloadAction<TCrumbSetPayload>) {
            const crumbId = state[payload.entityName]?.breadcrumbs.findIndex(
                crumbItem => crumbItem.key === payload.crumb?.key,
            );
            return crumbId === -1 ? {
                ...state,
                [payload.entityName]: {
                    breadcrumbs: [...state[payload.entityName]?.breadcrumbs, payload.crumb],
                },
            }
                : state;
        },
    },
});

export const {reducer: breadcrumbsSliceReducer} = breadcrumbsSlice;

export const {
    setBreadcrumbs,
    replaceBreadcrumbs,
    pushCrumb,
} = breadcrumbsSlice.actions;
